<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormSelect fieldName="seller_id"
                                    label="Seller"
                                    size="3"
                                    :options="select?.sellers"
                                    v-model:field="search.seller_id" />

                        <FormInputText fieldName="marketplace_code"
                                       label="Marketplace"
                                       size="2"
                                       v-model:field="search.marketplace_code" />

                        <FormInputText fieldName="identity"
                                       label="Product ID"
                                       size="5"
                                       v-model:field="search.identity" />

                        <FormInputText fieldName="identity_type"
                                       label="ID type"
                                       size="2"
                                       v-model:field="search.identity_type" />

                        <FormInputText fieldName="offer_identity"
                                       label="Offer ID"
                                       size="4"
                                       v-model:field="search.offer_identity" />

                        <FormInputNumber fieldName="price_min"
                                         label="Price min"
                                         size="3"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.price_min" />

                        <FormInputNumber fieldName="price_max"
                                         label="Price max"
                                         size="3"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.price_max" />

                        <FormInputText fieldName="currency"
                                       label="Currency"
                                       size="2"
                                       v-model:field="search.currency" />

                        <FormInputNumber fieldName="quantity_min"
                                         label="Quantity min"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.quantity_min" />

                        <FormInputNumber fieldName="quantity_max"
                                         label="Quantity max"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.quantity_max" />

                        <FormInputText fieldName="status"
                                       label="Status"
                                       size="2"
                                       v-model:field="search.status" />

                        <FormInputText fieldName="title"
                                       label="Product name"
                                       size="6"
                                       v-model:field="search.title" />

                        <FormInputText fieldName="subtitle"
                                       label="Additional name"
                                       size="6"
                                       v-model:field="search.subtitle" />

                        <FormInputText fieldName="last_synced_at_from"
                                       label="Last synced at from"
                                       size="3"
                                       v-model:field="search.last_synced_at_from" />

                        <FormInputText fieldName="last_synced_at_to"
                                       label="Last synced at to"
                                       size="3"
                                       v-model:field="search.last_synced_at_to" />

                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from "@crud/FormInputText.vue";
import FormSelect from "@crud/FormSelect.vue";
import FormInputNumber from "@crud/FormInputNumber.vue";

import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

const options = ["sellers"];
const select = ref(null);

let search = ref({})

prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
